import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
import React from 'react';
import styles from './announcement.less';
const format = forTemplate('announcement');

export interface AnnouncementProps {
  url: string;
  title: string;
  html: string;
  type: string;
}

export const classNamesForType = (type: string) => {
  return {
    [styles.announcement]: true,
    [styles[`announcement-${type}`]]: !!type,
  };
};

const sendAnalytics = () => {
  Analytics.trackUE({
    category: Noun.HEADER,
    verb: Verb.OPENS,
    directObj: Noun.LANDING_TAB,
    context: {
      landingtab: 'Opened Announcement Link',
    },
  });
};

export const Announcement: React.FunctionComponent<AnnouncementProps> = ({
  url,
  title,
  html,
  type,
}) => (
  <div className={classNames(classNamesForType(type))}>
    <h3 className={styles.announcementHeader}>
      {url ? (
        <a
          className={styles.announcementHeaderLink}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={sendAnalytics}
        >
          {title}
        </a>
      ) : (
        title
      )}
    </h3>
    {/* tslint:disable-next-line:react-no-dangerous-html */}
    <p dangerouslySetInnerHTML={{ __html: html }} />
    {url && (
      <p className={styles.quiet}>
        <a href={url} target="_blank" rel="noopener noreferrer">
          {format('read-more-ellipsis')}
        </a>
      </p>
    )}
  </div>
);



// WEBPACK FOOTER //
// ./app/gamma/src/components/popovers/announcements/announcement.tsx